import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage=lazy(()=>import('src/pages/dashboard/app'))

// WEBSITE
const WebsitePage=lazy(()=>import('src/pages/website'));

// EMAIL
const EmailPage=lazy(()=>import('src/pages/email'))

// ----------------------------------------------------------------------

export const appRoutes = [
  {
    path: '/',
    element: (
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
    ),
    children: [
      { element: <IndexPage />, index: true },
      {
        path: 'website',
        children: [
           { element: <WebsitePage />, index: true }
         ],
       },
       {
        path: 'email',
        children: [
           { element: <EmailPage />, index: true }
         ],
       },
    ],
  },
];
